import { roundToOneDecimal } from '@/pages/OperationsInsights/utils/roundNumber';
import { EnrichedAssignmentMetricsByWorkload } from '@/pages/OperationsInsights/types/AssignmentMetricsResponseEnriched';

/**
 * Transform Grid Data for - Assignment Summary by Workload
 *
 * @param metrics
 */
export const tfGdAssignmentSummaryByWorkload = (metrics: EnrichedAssignmentMetricsByWorkload[]) => {
    const gridMap = new Map<number, object>();
    for (const assignmentMetric of metrics) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const row: any = {
            name: assignmentMetric.name,
            openWithinSLABoP: assignmentMetric.openWithinSLABoP,
            openWithinSLAEoP: assignmentMetric.openWithinSLAEoP,
            openAtRiskBoP: assignmentMetric.openAtRiskBoP,
            openAtRiskEoP: assignmentMetric.openAtRiskEoP,
            openBreachedBoP: assignmentMetric.openBreachedBoP,
            openBreachedEoP: assignmentMetric.openBreachedEoP,

            completedWithinSLA: assignmentMetric.completedWithinSLA,
            completedBreached: assignmentMetric.completedBreached,
            averageCompletionTimeInMinutes: roundToOneDecimal(assignmentMetric.averageCompletionTimeInMinutes)
        };
        gridMap.set(assignmentMetric.workloadId, row);
    }
    return Array.from(gridMap.values());
};

/**
 * Colum Definition for Assignment Summary by Workload
 */
export const getAssignmentSummaryByWorkloadColumnDefs = () => {
    return [
        {
            field: 'name', headerName: 'Workload', minWidth: 220, filter: true
        },
        {
            field: 'openWithinSLABoP', headerName: 'Open within SLA (BoP)', filter: true
        },
        {
            field: 'openWithinSLAEoP', headerName: 'Open within SLA (EoP)', filter: true
        },

        {
            field: 'openAtRiskBoP', headerName: 'Open at Risk (BoP)', filter: true
        },
        {
            field: 'openAtRiskEoP', headerName: 'Open at Risk (EoP)', filter: true
        },

        {
            field: 'openBreachedBoP', headerName: 'Open Breached (BoP)', filter: true
        },
        {
            field: 'openBreachedEoP', headerName: 'Open Breached (EoP)', filter: true
        },

        {
            field: 'completedWithinSLA', headerName: 'Completed in SLA', filter: true
        },
        {
            field: 'completedBreached', headerName: 'Completed Breached', filter: true
        },
        {
            field: 'averageCompletionTimeInMinutes', headerName: 'Average Time to Completion in Min', filter: true
        }
    ];
};